import Cookies from 'js-cookie';

const WELCOME_COOKIE_NAME = 'hide-welcome-modal';
const INTRO_COOKIE_NAME = 'hide-intro-modal';
const EARTHQUAKE_COOKIE_NAME = 'hide-earthquake-modal';
const STATIONS_COOKIE_NAME = 'hide-stations-modal';
const ADVANCED_MODE_COOKIE_NAME = 'hide-advanced-mode-modal';

export class ModalService {
  constructor() {
    this.welcomeModal = document.getElementById('welcome-modal');
    this.introModal = document.getElementById('intro-modal');
    this.earthquakeModal = document.getElementById('earthquake-modal');
    this.stationsModal = document.getElementById('stations-modal');
    this.advancedModeModal = document.getElementById('advanced-mode-modal');

    if (Cookies.get(WELCOME_COOKIE_NAME) !== 'true') {
      this.showWelcomeModal();
    }

    this.addListeners();
  }

  addListeners() {
    document.getElementById('close-welcome-modal').addEventListener('click', () => {
      const shouldDisableModal = document.getElementById('welcome-modal-dont-show').checked;
      Cookies.set(WELCOME_COOKIE_NAME, shouldDisableModal);
      this.hideWelcomeModal();
    });

    document.getElementById('close-intro-modal').addEventListener('click', () => {
      const shouldDisableModal = document.getElementById('intro-modal-dont-show').checked;
      Cookies.set(INTRO_COOKIE_NAME, shouldDisableModal);
      this.hideIntroModal();
    });

    document.getElementById('close-earthquake-modal').addEventListener('click', () => {
      const shouldDisableModal = document.getElementById('earthquake-modal-dont-show').checked;
      Cookies.set(EARTHQUAKE_COOKIE_NAME, shouldDisableModal);
      this.hideEarthquakeModal();
    });

    document.getElementById('close-stations-modal').addEventListener('click', () => {
      const shouldDisableModal = document.getElementById('stations-modal-dont-show').checked;
      Cookies.set(STATIONS_COOKIE_NAME, shouldDisableModal);
      this.hideStationsModal();
    });

    document.getElementById('close-advanced-mode-modal').addEventListener('click', () => {
      const shouldDisableModal = document.getElementById('advanced-mode-modal-dont-show').checked;
      Cookies.set(ADVANCED_MODE_COOKIE_NAME, shouldDisableModal);
      this.hideAdvancedModeModal();
    });
  }

  showWelcomeModal() {
    this.showModal(this.welcomeModal);
  }

  hideWelcomeModal() {
    this.hideModal(this.welcomeModal);
  }

  showIntroModal() {
    if (Cookies.get(INTRO_COOKIE_NAME) !== 'true') {
      this.showModal(this.introModal);
    }
  }

  hideIntroModal() {
    this.hideModal(this.introModal);
  }

  showEarthquakeModal(hasTargetSites) {
    const hideForTargetSites = document.querySelectorAll('.earthquake-modal--hide-for-target-sites');
    const showForTargetSites = document.querySelectorAll('.earthquake-modal--show-for-target-sites');

    if (hasTargetSites) {
      showForTargetSites.forEach((element) => {
        element.classList.add('p--shown');
      });
      hideForTargetSites.forEach((element) => {
        element.classList.remove('p--shown');
      });
    } else {
      showForTargetSites.forEach((element) => {
        element.classList.remove('p--shown');
      });
      hideForTargetSites.forEach((element) => {
        element.classList.add('p--shown');
      });
    }
    if (Cookies.get(EARTHQUAKE_COOKIE_NAME) !== 'true') {
      this.showModal(this.earthquakeModal);
    }
  }

  hideEarthquakeModal() {
    this.hideModal(this.earthquakeModal);
  }

  showStationsModal() {
    if (Cookies.get(STATIONS_COOKIE_NAME) !== 'true') {
      this.showModal(this.stationsModal);
    }
  }

  hideStationsModal() {
    this.hideModal(this.stationsModal);
  }

  showAdvancedModeModal() {
    if (Cookies.get(ADVANCED_MODE_COOKIE_NAME) !== 'true') {
      this.showModal(this.advancedModeModal);
    }
  }

  hideAdvancedModeModal() {
    this.hideModal(this.advancedModeModal);
  }

  showModal(modal) {
    modal.classList.add('modal--shown');
  }

  hideModal(modal) {
    modal.classList.remove('modal--shown');
  }
}
